// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"727":"b8c624b1c8f74e73","950":"ab34ba6dc2c80a84"}[chunkId] + ".css";
};